export default {
  getFinanciamentos(state) {
    return state.financiamentos
  }
}
